<div class="questionnaires-container" role="main">
  <!-- Breadcrumb -->
  <nav class="breadcrumb-wrapper" aria-label="Navigazione breadcrumb">
    <p-breadcrumb [model]="breadcrumbItems()" [home]="{ icon: 'pi pi-home', routerLink: '/' }" />
  </nav>

  <!-- Page Header -->
  <div class="page-header">
    <div class="header-content">
      <h1 id="page-title">
        <i class="pi pi-file-edit" aria-hidden="true"></i> Gestisci configurazioni questionari
      </h1>
      <div class="header-buttons" role="group" aria-label="Azioni principali">
        <p-button
          label="+ Configurazione questionario"
          icon="pi pi-plus"
          (onClick)="onCreateNew()"
          styleClass="p-button-primary"
          ariaLabel="Crea nuova configurazione questionario"
          title="Crea nuova configurazione questionario"
        />
        <p-button
          label="+ Configurazione allegati"
          icon="pi pi-paperclip"
          (onClick)="onCreateAttachmentConfig()"
          styleClass="p-button-secondary"
          ariaLabel="Crea nuova configurazione allegati"
          title="Crea nuova configurazione allegati"
        />
      </div>
    </div>
  </div>

  <!-- Filters Section -->
  <section class="filters-section" aria-labelledby="filters-heading">
    <h2 id="filters-heading" class="sr-only">Filtri di ricerca</h2>
    <div class="filters-grid">
      <div class="filter-item">
        <label for="filter-template" class="sr-only">Filtra per template</label>
        <p-select
          id="filter-template"
          [options]="templateOptions"
          [(ngModel)]="selectedTemplate"
          optionLabel="label"
          placeholder="Template"
          [style]="{ width: '100%' }"
          aria-label="Seleziona template"
        />
      </div>

      <div class="filter-item">
        <label for="filter-category" class="sr-only">Filtra per categoria fiduciario</label>
        <p-multiSelect
          id="filter-category"
          [options]="categoryOptions"
          [(ngModel)]="selectedCategory"
          optionLabel="label"
          placeholder="Categoria fiduciario"
          [style]="{ width: '100%' }"
          aria-label="Seleziona categorie fiduciario"
        />
      </div>

      <div class="filter-item">
        <label for="filter-author" class="sr-only">Filtra per autore</label>
        <p-select
          id="filter-author"
          [options]="authorOptions"
          [(ngModel)]="selectedAuthor"
          optionLabel="label"
          placeholder="Autore"
          [style]="{ width: '100%' }"
          aria-label="Seleziona autore"
        />
      </div>

      <div class="filter-item">
        <label for="filter-status" class="sr-only">Filtra per stato</label>
        <p-select
          id="filter-status"
          [options]="statusOptions"
          [(ngModel)]="selectedStatus"
          optionLabel="label"
          placeholder="Stato"
          [style]="{ width: '100%' }"
          aria-label="Seleziona stato"
        />
      </div>

      <div class="filter-item date-filter">
        <fieldset>
          <legend>Data creazione</legend>
          <div class="date-inputs">
            <label for="creation-date-from" class="sr-only">Data creazione dal</label>
            <input
              id="creation-date-from"
              type="date"
              pInputText
              [(ngModel)]="creationDateFrom"
              placeholder="gg / MM / yyyy"
              aria-label="Data creazione dal"
            />
            <span class="date-separator" aria-hidden="true">-</span>
            <label for="creation-date-to" class="sr-only">Data creazione al</label>
            <input
              id="creation-date-to"
              type="date"
              pInputText
              [(ngModel)]="creationDateTo"
              placeholder="gg / MM / yyyy"
              aria-label="Data creazione al"
            />
            <button
              pButton
              type="button"
              icon="pi pi-calendar"
              class="p-button-text"
              aria-label="Apri calendario per data creazione"
            ></button>
          </div>
        </fieldset>
      </div>

      <div class="filter-item date-filter">
        <fieldset>
          <legend>Data modifica</legend>
          <div class="date-inputs">
            <label for="modification-date-from" class="sr-only">Data modifica dal</label>
            <input
              id="modification-date-from"
              type="date"
              pInputText
              [(ngModel)]="modificationDateFrom"
              placeholder="gg / MM / yyyy"
              aria-label="Data modifica dal"
            />
            <span class="date-separator" aria-hidden="true">-</span>
            <label for="modification-date-to" class="sr-only">Data modifica al</label>
            <input
              id="modification-date-to"
              type="date"
              pInputText
              [(ngModel)]="modificationDateTo"
              placeholder="gg / MM / yyyy"
              aria-label="Data modifica al"
            />
            <button
              pButton
              type="button"
              icon="pi pi-calendar"
              class="p-button-text"
              aria-label="Apri calendario per data modifica"
            ></button>
          </div>
        </fieldset>
      </div>
    </div>
  </section>

  <!-- Table Section -->
  <section class="table-section" role="region" aria-labelledby="table-caption">
    <h2 id="table-caption" class="sr-only">Elenco configurazioni questionari</h2>
    <p-table
      [value]="questionnaires()"
      [loading]="loading()"
      [paginator]="true"
      [rows]="10"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Mostra da {first} a {last} di {totalRecords} elementi"
      [rowsPerPageOptions]="[10, 25, 50]"
      styleClass="p-datatable-sm"
      ariaLabel="Tabella configurazioni questionari"
    >
      <ng-template pTemplate="header">
        <tr>
          <th scope="col">
            <div class="header-cell">
              <span>ID</span>
              <p-iconField iconPosition="left">
                <p-inputIcon styleClass="pi pi-search" />
                <input
                  id="search-id"
                  pInputText
                  type="text"
                  [(ngModel)]="searchId"
                  placeholder="Cerca ID"
                  class="search-input"
                  aria-label="Cerca per ID"
                />
              </p-iconField>
            </div>
          </th>
          <th scope="col">
            <div class="header-cell">
              <span>Nome configurazione</span>
              <p-iconField iconPosition="left">
                <p-inputIcon styleClass="pi pi-search" />
                <input
                  id="search-config-name"
                  pInputText
                  type="text"
                  [(ngModel)]="searchConfigName"
                  placeholder="Cerca nome configurazione"
                  class="search-input"
                  aria-label="Cerca per nome configurazione"
                />
              </p-iconField>
            </div>
          </th>
          <th scope="col">
            <div class="header-cell">
              <span>Categoria fiduciario</span>
              <p-multiSelect
                id="table-filter-category"
                [options]="categoryOptions"
                [(ngModel)]="selectedCategory"
                optionLabel="label"
                placeholder="Tutti"
                [style]="{ width: '100%' }"
                aria-label="Filtra per categoria fiduciario nella tabella"
              />
            </div>
          </th>
          <th scope="col">
            <div class="header-cell">
              <span>Autore</span>
              <p-iconField iconPosition="left">
                <p-inputIcon styleClass="pi pi-search" />
                <input
                  id="search-author"
                  pInputText
                  type="text"
                  [(ngModel)]="searchAuthor"
                  placeholder="Cerca autore"
                  class="search-input"
                  aria-label="Cerca per autore"
                />
              </p-iconField>
            </div>
          </th>
          <th scope="col">Data creazione</th>
          <th scope="col">Data modifica</th>
          <th scope="col">
            <div class="header-cell">
              <span>Ultima modifica da</span>
              <p-iconField iconPosition="left">
                <p-inputIcon styleClass="pi pi-search" />
                <input
                  id="search-modified-by"
                  pInputText
                  type="text"
                  [(ngModel)]="searchModifiedBy"
                  placeholder="Cerca"
                  class="search-input"
                  aria-label="Cerca per chi ha modificato"
                />
              </p-iconField>
            </div>
          </th>
          <th scope="col">
            <div class="header-cell">
              <span>Stato</span>
              <p-select
                id="table-filter-status"
                [options]="statusOptions"
                [(ngModel)]="selectedStatus"
                optionLabel="label"
                placeholder="Tutti"
                [style]="{ width: '100%' }"
                aria-label="Filtra per stato nella tabella"
              />
            </div>
          </th>
          <th scope="col">Azioni</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-questionnaire>
        <tr>
          <td>{{ questionnaire.id }}</td>
          <td>{{ questionnaire.configName }}</td>
          <td>{{ questionnaire.trusteeCategory }}</td>
          <td>{{ questionnaire.author }}</td>
          <td>
            <time [attr.datetime]="questionnaire.creationDate">{{
              questionnaire.creationDate
            }}</time>
          </td>
          <td>
            <time [attr.datetime]="questionnaire.lastModified">{{
              questionnaire.lastModified
            }}</time>
          </td>
          <td>{{ questionnaire.modifiedBy }}</td>
          <td>
            <p-tag
              [value]="getStatusLabel(questionnaire.status)"
              [severity]="getStatusSeverity(questionnaire.status)"
              [attr.aria-label]="'Stato: ' + getStatusLabel(questionnaire.status)"
            />
          </td>
          <td>
            <p-button
              icon="pi pi-eye"
              [rounded]="true"
              [text]="true"
              severity="info"
              (onClick)="onViewDetails(questionnaire)"
              pTooltip="Visualizza dettagli"
              [ariaLabel]="'Visualizza dettagli per ' + questionnaire.configName"
              [title]="'Visualizza dettagli per ' + questionnaire.configName"
            />
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="9" class="text-center" role="status" aria-live="polite">
            Nessun questionario trovato.
          </td>
        </tr>
      </ng-template>
    </p-table>
  </section>
</div>
